var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polygon, _path3, _circle, _path4, _circle2, _rect8, _rect9, _path5, _path6, _rect0, _rect1, _rect10, _polygon2, _path7, _path8, _path9, _line9, _circle3, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line0, _circle4, _path28, _rect11, _rect12, _line1, _path29, _path30, _path31, _path32, _rect13, _line10, _path33, _path34, _circle5, _circle6, _path35, _path36, _path37, _circle7, _circle8, _rect14, _rect15, _path38, _path39, _polygon3, _rect16;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMercurioEmptyStatePedidos = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 288,
    viewBox: "0 0 346 288",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.57,
    y: 23,
    width: 195,
    height: 255,
    rx: 10.19,
    fill: "#c6f1e1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 179.14,
    width: 184,
    height: 39.2,
    fill: "#fafafa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 101.44,
    width: 180.25,
    height: 39.2,
    fill: "#fafafa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.89,
    y: 109.54,
    width: 18.72,
    height: 18.72,
    rx: 2.6,
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.83,123.06a1.14,1.14,0,0,1-.69-.23L54.36,120a1.16,1.16,0,1,1,1.23-2l.16.12,3,2.21,5.91-6.42a1.16,1.16,0,0,1,1.71,1.56h0l-6.62,7.18A1.12,1.12,0,0,1,58.83,123.06Z",
    fill: "#fafafa"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.28,
    y: 70.45,
    width: 18.72,
    height: 18.72,
    rx: 2.6,
    fill: "none",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.89,
    y: 148.85,
    width: 18.72,
    height: 18.72,
    rx: 2.6,
    fill: "none",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50.89,
    y: 187.15,
    width: 18.72,
    height: 18.72,
    rx: 2.6,
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.83,200.68a1.14,1.14,0,0,1-.69-.23l-3.78-2.84a1.16,1.16,0,1,1,1.23-2,.83.83,0,0,1,.16.12l3,2.21,5.91-6.43a1.16,1.16,0,0,1,1.71,1.57h0l-6.62,7.18A1.16,1.16,0,0,1,58.83,200.68Z",
    fill: "#fafafa"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 117.48,
    x2: 136.78,
    y2: 117.48,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 121.59,
    x2: 183.35,
    y2: 121.59,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 195.18,
    x2: 136.78,
    y2: 195.18,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 199.29,
    x2: 183.35,
    y2: 199.29,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 78.21,
    x2: 136.78,
    y2: 78.21,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 82.32,
    x2: 183.35,
    y2: 82.32,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 156.75,
    x2: 136.78,
    y2: 156.75,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 81.53,
    y1: 160.86,
    x2: 183.35,
    y2: 160.86,
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "53.83 47.67 62.54 59.04 70 47.67 53.83 47.67",
    fill: "#01ffc8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.26,250.4s-28.39,14.34-29,17.5a26.9,26.9,0,0,0,0,7.17l1-1,2.73-6.45,25.53-12Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.1,
    cy: 275.15,
    r: 4.25,
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.58,250.4s28.39,14.34,29,17.45a26.9,26.9,0,0,1,0,7.17l-1-1-2.72-6.44-25.52-12Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.73,
    cy: 275.15,
    r: 4.25,
    fill: "#262626"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 250.69,
    y: 203.65,
    width: 4.59,
    height: 49.9,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 246.39,
    y: 208.52,
    width: 13.48,
    height: 9.18,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.34,199.31c-9.75-1-42.14-3.88-71.07,0a1.14,1.14,0,0,0-.66,2c2.84,2.83,11.16,8.3,33.64,9.78,22.87,1.49,34.42-5.61,38.83-9.33a1.4,1.4,0,0,0-.74-2.43Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.2,201.89h71.7l.2-.16a1.41,1.41,0,0,0,.13-2,1.39,1.39,0,0,0-.9-.48c-9.67-1-41.59-3.83-70.31,0a1.5,1.5,0,0,0-1.37,1.64A1.47,1.47,0,0,0,214.2,201.89Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 247.83,
    y: 245.8,
    width: 10.61,
    height: 11.19,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 251.43,
    y: 251.4,
    width: 2.34,
    height: 25.67,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 249.84,
    y: 270.38,
    width: 5.51,
    height: 9.05,
    fill: "#262626"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.36 143.27 218.45 152.29 218.9 158.72 240.19 157 240.19 146.06 227.36 143.27",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.08,69.6c-12-4.42-15.21,6.56-15.75,9.78s.07,6.27.64,9.51-.91,7.19-2.43,10.08c-1.78,3.39-5.94,6-5.34,9.8.49,3,3.91,5,3.82,8-.07,2.38-2.31,4-3.41,6.15-2.07,4,.1,8.76,2.28,12.69.89,1.63,2,3.42,3.82,3.79,2.51.5,4.51-1.95,6-4a43.53,43.53,0,0,1,16.43-13.12",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.51,135.12s4.89,11.58,16.66,10.71l1.46,15.44s12.4,9.66,16.44,11.44,11.09-3.19,16.49-1,12.48,0,12.48,0c.32-6.41-6.62-15.56-10.45-20.12a14.38,14.38,0,0,1-3.45-10.18c0-.23,0-.47.06-.7.91-8.49,2.56-22.23-.69-29.07-2.13-4.5-15.42-6.62-15.42-6.62l-15.36,3.17-7.06,6.19a6.43,6.43,0,0,0-2.1,3.8l-9.06,16.92",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.56,238.17l11.2,26.7-28.47,13.55a7.46,7.46,0,0,1,.09-1.72c.44-2.83,2.5-8.65,11.74-13.44,0,0,.2-14.64-4.84-19.66Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 255.94,
    y1: 263.15,
    x2: 228.33,
    y2: 276.29,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.44,
    cy: 259.05,
    r: 2.63,
    fill: "#01ffc8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M233.34,202a7.43,7.43,0,0,1-1.84.78,9.16,9.16,0,0,1-5.29,0h-.09l.07-.06a11.37,11.37,0,0,1,4.07-2.54,12.11,12.11,0,0,1,5.5-.65,9.9,9.9,0,0,1,1.78.38,5.42,5.42,0,0,1,1.62.7,1.61,1.61,0,0,1,.7,1.53,1.75,1.75,0,0,1-1.16,1.13,25.87,25.87,0,0,1-5.49,1.26,26.58,26.58,0,0,1-3.79.16,8.69,8.69,0,0,1-1.39-.09h.36l1,0a29.73,29.73,0,0,0,3.78-.21,26.22,26.22,0,0,0,5.45-1.3,1.61,1.61,0,0,0,1.08-1,1.47,1.47,0,0,0-.65-1.4,5.07,5.07,0,0,0-1.58-.69,13.29,13.29,0,0,0-1.75-.37,12,12,0,0,0-5.45.61,11.62,11.62,0,0,0-4,2.5v-.09a9.24,9.24,0,0,0,5.21.06,9.58,9.58,0,0,0,1.39-.5Z",
    fill: "#262626"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M232.13,232.71a1.86,1.86,0,0,1,.35-.22,10.23,10.23,0,0,1,1-.47,11.13,11.13,0,0,1,7.25-.34,9.37,9.37,0,0,1,1,.38,2.53,2.53,0,0,1,.37.18l-.39-.13a11,11,0,0,0-1.05-.34,11.9,11.9,0,0,0-7.18.34c-.44.17-.79.32-1,.43A3.29,3.29,0,0,1,232.13,232.71Z",
    fill: "#262626"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.54,205.81a2.65,2.65,0,0,1-.11.28,6.55,6.55,0,0,0-.29.85,8.32,8.32,0,0,0-.21,3.22,16,16,0,0,0,1.31,4.64c.7,1.68,1.65,3.46,2.33,5.47a13.56,13.56,0,0,1,.65,3,12.61,12.61,0,0,1-.09,2.88,18.84,18.84,0,0,1-1.3,4.67,32.08,32.08,0,0,1-1.41,3c-.37.68-.59,1-.59,1l.13-.27.41-.79c.35-.69.85-1.69,1.37-3a19.33,19.33,0,0,0,1.3-4.66,12.35,12.35,0,0,0,.07-2.85,13.22,13.22,0,0,0-.65-3c-.65-2-1.61-3.78-2.32-5.47a16.48,16.48,0,0,1-1.3-4.67,8.53,8.53,0,0,1,.25-3.26A5.38,5.38,0,0,1,223.54,205.81Z",
    fill: "#262626"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.57,224.11v-.2c0-.14.07-.33.11-.58a11.89,11.89,0,0,0,.14-2.15,21.68,21.68,0,0,0-1.51-6.93c-1-2.61-2-4.94-2.48-6.7a16.78,16.78,0,0,1-.65-2.89.46.46,0,0,1,0,.2,2.55,2.55,0,0,0,.13.57c.1.5.28,1.22.55,2.09.52,1.75,1.53,4.07,2.51,6.68a20.91,20.91,0,0,1,1.53,7,11.19,11.19,0,0,1-.19,2.16A7.2,7.2,0,0,1,230.57,224.11Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.73,167.33c-3.1-3.72-7.74-6.53-12.57-6.24a28.65,28.65,0,0,0-11.22,3.61c-8.48,4.8-6.91,15.76-6.91,15.76l10.26,76.63,22-2.54-7.82-74.05,9.48-7.23Z",
    fill: "#262626"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237.46,94.61l.41,3.08,1.45,11,.35,2.24c1.46,3.78,11.64,1.09,13.63-2.48a24.81,24.81,0,0,1-1-2.81c-.94-3.72-2.18-8.61-2.71-10.68l-.14-.54-4.73.06Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M237.87,97.69l1.51,11.53c9.67-2.44,10.71-11.81,10.71-11.81l-.33-.79a74.46,74.46,0,0,0-9.48.25A6.28,6.28,0,0,0,237.87,97.69Z",
    fill: "#262626"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.54,87.4c-.64,9.26,3.35,17,8,17.52,7.55.86,16.86-6.06,17.5-15.31s-5-17.19-12.57-17.71S227.18,78.14,226.54,87.4Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M231.78,89.36s1.2,4.07.4,6.58a2.19,2.19,0,0,0,2.83-.41",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.32,91c-.41.14-.54.84-.29,1.57s.76,1.22,1.17,1.08.53-.83.29-1.56S229.72,90.83,229.32,91Z",
    fill: "#262626"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M238.14,88c-.4.13-.53.83-.29,1.56s.77,1.22,1.17,1.09.54-.84.29-1.57S238.54,87.9,238.14,88Z",
    fill: "#262626"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5,95c-.55,4.37-3.76,4-3.76,4",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M239.54,85.35a4,4,0,0,0-4.45,1.88",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.61,89.71a3.2,3.2,0,0,1,4-1.22",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.61,106.59,265,108l-.07-1.63A19.32,19.32,0,0,0,260,93.81c-1.95-2.2-1.52-4.13-.84-6.73a8.83,8.83,0,0,0-1.49-8.24,47.9,47.9,0,0,0-5.62-6.61,15.34,15.34,0,0,0-4.4-3.24c-5.94-2.6-24.46.81-22.53,10.23,0,0,1.18,3.38,1.33,3.53.74.73,5.35-3.27,6.15-3.6a.53.53,0,0,1,.5,0,.58.58,0,0,1,.15.25,4.73,4.73,0,0,0,4.22,2.86,15.62,15.62,0,0,0,2.93-.5,4.24,4.24,0,0,1,2.9.25c1.22.69,1.67,2.2,1.89,3.58a9,9,0,0,0,2.22,5.26c1.67,1.83,2,1.82,1.78,3.24l-.07.71c-.45,2.23-1.1,13.21,8.24,10.6l3.26,1.24",
    fill: "#262626"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246.15,89.08c.57-2.33,3.92-3.79,5-1,.82,2.23-1.54,5.76-4,4.32",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M258.17,122.41a53.68,53.68,0,0,1,2.61,17.9c-5.5,6.11-23,14.06-23,14.06a38.25,38.25,0,0,0-15.69-3.69L220,157l7.13,2c4.69,3.87,12.84,2.45,12.84,2.45,18.33-3.47,31.52-13.86,33-21.6s-3.85-26.48-3.85-26.48Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250.75,158.64v-1a1.92,1.92,0,0,0-1.92-1.92H213.47v2.88h37.26Z",
    fill: "#01ffc8",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M268.8,110.64l9.75,14.06s-11.85,16.07-20.31,9.3l-3.64-10.91",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.75,249.54l-2.06,28.88-31.53-.77a7.63,7.63,0,0,1,.86-1.49c1.67-2.33,6.14-6.59,16.55-6.69,0,0,6.78-13,4.56-19.72Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 224.73,
    y1: 276.51,
    x2: 194.16,
    y2: 275.77,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.89,
    cy: 269.46,
    r: 2.63,
    fill: "#01ffc8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M288.13,171.59s6.35,22.6-11,26.52l-27.62.27L236,257H207l15.32-65.31A14.75,14.75,0,0,1,233.81,179l35.78-7.83Z",
    fill: "#262626"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.12,
    y: 163.01,
    width: 5.08,
    height: 115.41,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 293.28,
    y: 163.01,
    width: 5.08,
    height: 115.41,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 14.32,
    y1: 278.42,
    x2: 337,
    y2: 278.42,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M233,126s-2.65,5.84,3.91,16.78l.26,3.05",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162.38,155.94l-9.7-38.88a3.71,3.71,0,0,1-.1-.88,3.66,3.66,0,0,1,3.66-3.67h54.84a3.66,3.66,0,0,1,3.55,2.78l9.76,38.88a3.72,3.72,0,0,1,.11.88,3.67,3.67,0,0,1-3.67,3.67H166A3.68,3.68,0,0,1,162.38,155.94Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5,155.94l-9.7-38.88a3.72,3.72,0,0,1-.11-.88,3.67,3.67,0,0,1,3.67-3.67h54.83a3.68,3.68,0,0,1,3.56,2.78l9.76,38.88a3.72,3.72,0,0,1,.11.88,3.67,3.67,0,0,1-3.67,3.67H163.12A3.67,3.67,0,0,1,159.5,155.94Z",
    fill: "#01ffc8",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.88,129.74c-2.65.63-4.19,3.77-3.42,7s3.55,5.36,6.21,4.74,4.18-3.77,3.42-7S184.54,129.12,181.88,129.74Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 101.82,
    y: 159.77,
    width: 202.99,
    height: 18.39,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 223.24,
    y1: 180.51,
    x2: 233.08,
    y2: 257.08,
    fill: "#262626",
    stroke: "#fafafa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.27,278.2l-47.88.22a4.91,4.91,0,0,1-4.89-5.58l6.82-49.42a4.91,4.91,0,0,1,4.84-4.24l33.77-.16a4.92,4.92,0,0,1,4.89,4.2l7.28,49.35A4.91,4.91,0,0,1,121.27,278.2Z",
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M106.48,226.11l0-3.76a9.4,9.4,0,1,0-18.8.09l0,3.76",
    fill: "none",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.48,
    cy: 227.05,
    r: 0.94,
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.69,
    cy: 227.13,
    r: 0.94,
    fill: "#34806b",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.07,258.48l-10.5,8L60.5,237.84l-13.83.06a3.27,3.27,0,0,0-3.22,2.83L38.9,273.66a3.28,3.28,0,0,0,3.26,3.72l31.9-.15a3.27,3.27,0,0,0,3.23-3.75Z",
    fill: "#262626"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M75.54,278.27l-31.91.15a3.27,3.27,0,0,1-3.26-3.72l4.55-32.93A3.26,3.26,0,0,1,48.15,239l22.5-.11a3.26,3.26,0,0,1,3.25,2.79l4.86,32.89A3.27,3.27,0,0,1,75.54,278.27Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68,243.56v-2.51a6.26,6.26,0,1,0-12.52.06v2.51",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.69,
    cy: 244.19,
    r: 0.63,
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.16,
    cy: 244.25,
    r: 0.63,
    fill: "#262626",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 110.67,
    y: 247.28,
    width: 43.27,
    height: 6.34,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 113.27,
    y: 253.62,
    width: 38.06,
    height: 24.81,
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.88,264.92a2.21,2.21,0,0,1-2.21,2.21H127.3a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.2h9.37a2.21,2.21,0,0,1,2.21,2.2Z",
    fill: "#fafafa",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136.67,262.72H127.3a2.2,2.2,0,0,0-2,1.29,2.18,2.18,0,0,1,.92-.21h9.37a2.2,2.2,0,0,1,2.2,2.21,2.17,2.17,0,0,1-.2.92,2.2,2.2,0,0,0-.92-4.21Z",
    fill: "#262626"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.28 256.8 151.15 253.53 113.28 253.53 113.28 256.8",
    fill: "#262626"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 44,
    width: 126,
    height: 15,
    rx: 7.5,
    fill: "#fafafa"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMercurioEmptyStatePedidos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mercurio_empty_state_pedidos.33a6d0ff.svg";
export { ForwardRef as ReactComponent };